export default {
    "charge": "Nạp tiền",
    "withdraw": "Hoàn tiền",
    "pst": "Phát sinh tăng",
    "psg": "Phát sinh giảm",
}
